import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router'; // Import ActivatedRoute if needed
import { SearchService } from 'src/app/services/search/search.service';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    FormsModule

  ]
})
export class SearchComponent implements OnChanges {
  @Input() searchValue: string = '';
  @Input() placeholder: string = 'Search...';
  @Input() buttonLabel: string = 'Go';
  @Output() submitValue: EventEmitter<string> = new EventEmitter<string>();

  inputValue: string = ''; // Local variable to bind to input

  constructor(
    private route: ActivatedRoute, // You may not need ActivatedRoute here
    private searchService: SearchService
  ) {}

  ngOnChanges(): void {
    this.inputValue = this.searchValue
      ? decodeURIComponent(this.searchValue)
      : '';
  }

  // search(query: string, results_index: number | null = 0, filters: any | null = null): void {
  //   this.searchService.search(query, results_index, filters).subscribe(
  //     (results) => {
  //       // Handle the search results here
  //     },
  //     (error: any) => {
  //       console.error('Error searching RCL', error.message);
  //     }
  //   );
  // }

  getCurrentInput(): string {
    return this.inputValue;
  }

  onSubmit(): void {
    const query = this.inputValue.trim();
    //if (query) {
      this.submitValue.emit(query);
      // this.search(query);
    //}
  }
}
